import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { IconButton, Paper, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(0.5),
  minWidth: 0,
  padding: theme.spacing(0.5),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
}));

export const TriggerButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.25),
  marginLeft: "auto",
  flexShrink: 0,
}));

export const ArrowIcon = styled(KeyboardArrowDownIcon, {
  shouldForwardProp: (prop) => prop !== "$open",
})<{ $open: boolean }>(({ $open, theme }) => ({
  fontSize: 20,
  color: theme.palette.text.secondary,
  transform: `rotate(${$open ? -180 : 0}deg)`,
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shorter,
  }),
}));

export const DropdownPaper = styled(Paper)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[4],
  overflow: "hidden",
}));
